import * as React from "react";
import { RouteComponentProps } from "react-router";

interface IDashboardProps extends Partial<RouteComponentProps> {

}

interface IDashboardState {

}

export class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
    constructor(props: Readonly<IDashboardProps>) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div>

            </div>
        );
    }

    componentDidMount(): void {
        
    }
}